import produce from 'immer';

import * as types from './types';

const initialState = {
  isCartActive: false,
  isFilterModalActive: false,
  isGlobalSearchActive: false,
  isLoading: false,
  isNavigationActive: false,
  isPetiteDropdownActive: false,
  isPromoBarActive: true,
  isSortActive: false
};

/* eslint-disable consistent-return */
/* eslint-disable default-case */
/* eslint-disable no-param-reassign */
const reducer = produce((draft, action) => {
  switch (action.type) {
    case types.INTERFACES_SET_PETITE_DROPDOWN_STATE:
      draft.isPetiteDropdownActive = action.isActive;
      break;

    case types.INTERFACES_TOGGLE_GLOBAL_SEARCH_VISIBILITY:
      draft.isGlobalSearchActive = action.isActive;
      break;

    case types.INTERFACES_SET_IS_CART_ACTIVE:
      draft.isCartActive = action.isActive;
      break;

    case types.INTERFACES_SET_IS_NAVIGATION_ACTIVE:
      draft.isNavigationActive = action.isActive;
      break;

    case types.INTERFACES_SET_IS_SORT_ACTIVE:
      draft.isSortActive = action.isActive;
      break;

    case types.INTERFACES_TOGGLE_IS_LOADING:
      draft.isLoading = action.isLoading;
      break;
  }
}, initialState);

export default reducer;
